/* eslint-disable camelcase */

import { enUS_analyticTitle } from './analytic/title';
import { enUS_globalTips } from './global/title';

const en_US = {
  ...enUS_globalTips,
  ...enUS_analyticTitle,
};

export default en_US;
